export default (values) => {
  const errors = {};

  if (!values?.uploadFor) errors.uploadFor = true;
  if (!values?.week) errors.week = true;
  if (!values?.schedule) errors.schedule = true;

  return errors;
};
